const tiersColor = {
  bronze: 'linear-gradient(307deg, #E1D1B9 20.51%, #B49C79 140.21%)',
  silver: 'linear-gradient(298deg, #B8BCBD -30.58%, #DADEDF 50.65%)', 
  gold: 'linear-gradient(127deg, #BFA766 11.33%, #CDB980 86.89%)',
  eip: 'linear-gradient(125deg, #031F27 29.56%, #053847 123.82%)', 
  eipplatinum: 'linear-gradient(127deg, #303138 37.84%, #67696E 126.6%)', 
}

export default {
  tiersColor,
}